// extracted by mini-css-extract-plugin
export default {"backdrop":"Loading_backdrop__lse4G","spinner":"Loading_spinner__3bQhz","spin":"Loading_spin__6wswR"};